import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Subscription } from 'rxjs';
import { SHeaderComponent } from '../../shared/s-header/s-header.component';
import { BaseTwoColumnTextImage } from './base-two-column-text-image/base-two-column-text-image.component';
import { ElementsType } from '../../../state-management/model/enums/state.enums';
import { CBaseComponent } from '../base/c-base.component';
import { ScreensizeStateService } from '../../../state-management/services/screensize-state.service';
import { CoordinatesSystem, ScreenWidthBreakpoints } from '../../../state-management/model/enums/screen-size.enums';

@Component({
    selector: 'app-c-two-column-text-image',
    imports: [
        MatGridListModule,
        MatButtonModule,
        RouterModule,
        CommonModule,
        SHeaderComponent,
        BaseTwoColumnTextImage
    ],
    templateUrl: './c-two-column-text-image.component.html',
    styleUrl: './c-two-column-text-image.component.scss',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CTwoColumnTextImageComponent extends CBaseComponent implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription();

  public rowHeight: string = '3:2';
  public isSmallScreen$: Signal<boolean> = this.screensizeState.isScreenSizes(CoordinatesSystem.ScreenWidth, [ScreenWidthBreakpoints.XSmall]);

  constructor(private screensizeState: ScreensizeStateService, private breakpointObserver: BreakpointObserver) {
    super();
  }

  override ngOnInit() {
    this.singleLabels = [ElementsType.ComponentHeader];
    this.groupLabels = [ElementsType.ComponentImageText];
    this.#setRowHeight();

    super.ngOnInit();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  #setRowHeight(): void {
    this.subscription.add(this.breakpointObserver.observe([
      '(min-width: 600px) and (max-width: 749.99px)',
      '(min-width: 750px) and (max-width: 959.99px)',
      '(min-width: 960px)'
    ]).subscribe((state: BreakpointState) => {
      if (state.breakpoints['(min-width: 600px) and (max-width: 749.99px)']) {
        this.rowHeight = '1:1.25';
      } else if (state.breakpoints['(min-width: 750px) and (max-width: 959.99px)']) {
        this.rowHeight = '1:1';
      } else if (state.breakpoints['(min-width: 960px)']) {
        this.rowHeight = '3:2';
      }
    })
    )
  }
}
